import { navigate } from "hookrouter";

const endpoint = "https://api.yazbie.com/api";

const get = async (path, token, args, setLoading) => {
  const url = new URL(endpoint);
  url.pathname = url.pathname + path + (args.sub ? args.sub : "");

  if (args.query) {
    url.search = new URLSearchParams(args.query);
  }
  setLoading(true);
  // alert(url);
  // console.log(path, token, args);
  try {
    const rawResponse = await fetch(url, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: token,
      },
    });

    try {
      // console.log(rawResponse);
      const content = await rawResponse.clone().json();
      // console.log(content);
      setLoading(false);
      return content;
    } catch (e) {
      setLoading(false);
      console.log(e);
      console.log(await rawResponse.clone().text());
      if (await (rawResponse.clone().text()).toLowerCase() === 'unauthorized') {
        localStorage.clear();
        navigate('/login');
      }
      return {
        success: false,
        message: rawResponse.statusText
          ? rawResponse.statusText
          : "Something went wrong",
        error: e,
      };
    }
  } catch (e) {
    setLoading(false);
    console.log(e);
    return {
      success: false,
      message: "Failed to reach server",
      error: e,
    };
  }
};

const set = async (path, token, formdata, setLoading, opts = {}) => {
  setLoading(true);
  let headers = {};
  if (token) {
    headers["Authorization"] = token;
  }

  if (opts.json) {
    headers["Content-Type"] = "application/json";
    headers["Accept"] = "application/json";
  }

  try {
    const rawResponse = await fetch(`${endpoint}${path}`, {
      method: "POST",
      headers: headers,
      body: formdata,
    });
    try {
      console.log(rawResponse);
      const content = await rawResponse.json();
      setLoading(false);
      console.log(content);
      if (opts.raw) {
        return {
          content: content,
          raw: rawResponse,
          success: true,
        };
      } else {
        return content;
      }
    } catch (e) {
      setLoading(false);
      return e;
    }
  } catch (e) {
    setLoading(false);
    return {
      success: false,
      message: "Failed to reach server",
      error: e,
    };
  }
};

const put = async (path, token, formdata, setLoading) => {
  setLoading(true);
  console.log("Updating data now");
  try {
    const rawResponse = await fetch(`${endpoint}${path}`, {
      method: "PUT",
      headers: {
        Authorization: token,
      },
      body: formdata,
    });
    try {
      const content = await rawResponse.json();
      setLoading(false);
      return content;
    } catch (e) {
      setLoading(false);
      return e;
    }
  } catch (e) {
    setLoading(false);
    return {
      success: false,
      message: "Failed to reach server",
      error: e,
    };
  }
};

const api = {
  get: get,
  set: set,
  put: put,
};

export default api;
